import { api } from "@/shared/api";
import type { AgencyClient } from "../model/types";

export async function fetchAgencyClients(): Promise<AgencyClient[]> {
  try {
    const res = await api.get<AgencyClient[]>("/api/agency/clients");
    return res.data || [];
  } catch (err: any) {
    console.error("Ошибка при получении клиентов агентства:", err);
    throw err;
  }
}
